/**
 * Created by akirilyuk on 12/8/16.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        template = require("connection-templates/ticketTab/ArticleSuggestionsLoadingView.tmpl"),
        Loader = require("ui/loader/Loader"),
        ArticleSuggestionsLoadingView = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        ArticleSuggestionsLoadingView = Marionette.ItemView.extend({
            template: template,
            className: 'loading-view',
            ui: {
                loaderContainer: ".loading-view-container"
            },
            onRender: function(){
                this._setLoader();
            },
            _setLoader:function(){
                this._getLoader().render();
            },

            _closeLoader: function () {
                this._getLoader().close();
            },

            _getLoader:function(){
                if (!this.loader) {
                    this.loader = new Loader({
                        permutation: Loader.PERMUTATION.C,
                        text: LE.translator.translate("LEConnection.cases.createView.suggestions.loadingMessage"),
                        el: this.ui.loaderContainer,
                        zIndex:2
                    });
                }
                return this.loader;
            }
        });
    });
    return ArticleSuggestionsLoadingView;
});
